<div class="select-payment-container d-flex flex-column gap-4">
  <div class="payment-detail-container d-flex flex-column gap-4">
    <button type="button" class="btn btn-primary home-btn" (click)="onClickHomeButton()">
      <i class="fa-solid fa-house me-2"></i>Home
    </button>

    <app-custom-modal
      #abortModalRef
      [modalId]="'abortConfirmModal'"
      [title]="'Are you sure?'"
      [message]="'Navigating to the home screen will abort the current court payment process. Do you want to cancel?'"
      [confirmButtonText]="'Yes'"
      [cancelButtonText]="'No'"
      [showConfirmOnly]="false"
      (onCloseModel)="handleAbortModalClose($event)"
    ></app-custom-modal>


    <app-confirmation-modal-with-dynamic-component
       #depositRecordModalRef
      [title]="'Please Confirm the Details'"
      (onClose)="handleConfirmationModalClose($event)"
      [confirmButtonText]="'Proceed'"
      [cancelButtonText]="'Edit'"
      [modalSize]="'xl'"
    ></app-confirmation-modal-with-dynamic-component>

    <div class="court-deposits card rounded p-3 d-flex flex-column gap-4">
      <span class="court-deposits-heading">Court Deposits<span *ngIf="depositCategorySelected">: {{ depositCategorySelected.name }}</span></span>

      <div class="p-3" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
        <strong>General Information and Instructions:</strong>
        <ul class="mt-2 mb-0 ps-3">
          <li class="mb-2">Please enter all mandatory fields marked with ( * ).</li>
          <li class="mb-2" *ngIf="isSheriffBailiffDeposit">
            For EOA cases, please enter the Main Case number under both Case number and Sub Case number.
          </li>
          <li class="mb-2" *ngIf="isSheriffBailiffDeposit">
            Please provide the necessary details required for Court Deposit.
            <button type="button"
                    class="btn btn-example retrieve-button ms-2 mt-2 mt-sm-0"
                    style="background-color: #b98bcf;"
                    data-bs-toggle="modal"
                    data-bs-target="#courtDepositHelpModal">
              Where to find the details?
            </button>
          </li>
        </ul>

      </div>
      <div class="modal fade" id="courtDepositHelpModal" tabindex="-1" aria-labelledby="courtDepositHelpModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content border-0 help-modal-content">
            <div class="d-flex flex-column justify-content-between">
              <div class="modal-body mt-0">
                <ul class="nav nav-tabs help-tabs d-flex flex-wrap w-100">
                    <li class="nav-item" *ngIf="isSheriffBailiffDeposit">
                      <button type="button" class="nav-link active" data-bs-toggle="tab" data-bs-target="#SHERIFF_BAILIFF_DEPOSIT">Bailiff/Sheriff</button>
                    </li>
                  <li class="nav-item ms-auto d-flex align-items-center">
                    <button type="button"
                            class="nav-link active"
                            data-bs-dismiss="modal"
                            aria-label="Close">
                      <i class="fa-solid fa-xmark fa-xl"></i>
                    </button>
                  </li>
                </ul>

                <div class="tab-content">
                  <div class="tab-pane fade show active" id="SHERIFF_BAILIFF_DEPOSIT" *ngIf="isSheriffBailiffDeposit">
                    <img src="assets/images/sheriff&bailiff.png" alt="Bailiff/Sheriff Help" class="img-fluid w-100 help-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="deposit-section d-flex flex-column gap-3">
        <div class="info-general d-flex justify-content-between">
          <!-- LEFT COLUMN -->
          <div class="left-column d-flex flex-column gap-3">
            <!-- Deposit Category -->
            <div *ngIf="!isDepositCategoryHidden" class="form-group">
              <span class="col-form-label">Deposit Category <strong class="text-danger">*</strong></span>
              <div class="drop-down">
                <app-drop-down
                  [dataSource]="depositCategoryDropdownValues"
                  placeholder="Select Deposit Category"
                  name="depositCategory"
                  [value]="depositCategorySelected"
                  (selectedOption)="onDepositCategorySelected($event)"
                  (touched)="depositCategoryTouched = true"
                  [disabled]="depositCategorySelected !== null">
                </app-drop-down>
                <div class="text-danger mt-1" *ngIf="depositCategoryTouched && !depositCategory">
                  <span class="error-icon">–</span>Deposit Category is required.
                </div>
              </div>
            </div>

            <div class="info-general d-flex justify-content-between">
              <div class="left-column d-flex flex-column gap-3">
                <div class="form-group">
                  <span class="col-form-label">Deposit Type <strong class="text-danger">*</strong></span>
                  <div class="drop-down">
                    <app-drop-down
                      [dataSource]="depositTypeDropdownValues"
                      placeholder="Select Deposit Type"
                      (selectedOption)="onDepositTypeSelected($event)"
                      (touched)="depositTypeTouched = true">
                    </app-drop-down>
                    <div class="text-danger mt-1" *ngIf="depositTypeTouched && !depositType">
                      <span class="error-icon">–</span>Deposit Type is required.
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-column d-flex flex-column gap-3">
                <div class="form-group" style="max-width: 400px">
                  <span *ngIf="isCourtApplicable" class="col-form-label">Court<strong class="text-danger">*</strong></span>
                  <div *ngIf="isCourtApplicable" class="">
                    <app-drop-down
                      [dataSource]="courtDropdownValues"
                      placeholder="Select Court"
                      displayField="label"
                      valueField="value"
                      (selectedOption)="onCourtSelected($event)"
                      (touched)="courtTouched = true">
                    </app-drop-down>
                    <div class="text-danger mt-1" *ngIf="courtTouched && !selectedCourt">
                      <span class="error-icon">–</span>Court selection is required.
                    </div>
                  </div>
                </div>
              </div>

            </div>


            <div class="info-general d-flex justify-content-between">
              <div class="left-column d-flex flex-column gap-3">
                <!-- Case Number -->
                <div class="form-group" style="max-width: 400px">
                  <label for="case-number" class="col-form-label">Case Number <strong class="text-danger" *ngIf="isCaseNumberMandatory">*</strong></label>
                  <input id="case-number" class="form-control form-control-md vkeyboard uppercase-input" type="text" [(ngModel)]="caseNumber" [required]="isCaseNumberMandatory"
                         [placeholder]="isSheriffBailiffDeposit ? 'eg: HC/OC XXXX/YYYY' : 'Enter Case Number'" #caseNo="ngModel"/>
                  <div *ngIf="caseNo.invalid && caseNo.touched" class="text-danger mt-1">
                    <span class="error-icon">–</span>Case Number is required.
                  </div>
                </div>
              </div>
              <div class="right-column d-flex flex-column gap-3">
                <!-- Subcase Number -->
                <div class="form-group" style="max-width: 400px">
                  <label for="sub-case-number" class="col-form-label">Subcase Number <strong class="text-danger" *ngIf="isSubCaseNumberMandatory">*</strong></label>
                  <input id="sub-case-number" class="form-control form-control-md vkeyboard uppercase-input" type="text" [(ngModel)]="subCaseNumber" #subCaseNo="ngModel" [required]="isSubCaseNumberMandatory"
                         [placeholder]="isSheriffBailiffDeposit ? 'eg: HC/EO XXXX/YYYY' : 'Enter Subcase Number'"/>
                  <div *ngIf="subCaseNo.invalid && subCaseNo.touched" class="text-danger mt-1">
                    <span class="error-icon">–</span>SubCase Number is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="p-3 mb-1" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;" *ngIf="isSheriffBailiffDeposit">
              <div class="mt-0 mb-0">
                Please ensure that you enter the correct prefix for the case and subcase number indicated in the letter. E.g. DC, DCA, MC, EOA, ECT, ECORC, MOM, PHA, RAS, SCT, FC, HCF, HC or SIC.
              </div>
            </div>

            <div class="info-general d-flex justify-content-between">
              <div class="left-column d-flex flex-column gap-3">
                <!-- Payer ID -->
                <div class="form-group" style="max-width: 400px">
                  <label for="payer-id" class="col-form-label">Payer ID / UEN / FIN<strong class="text-danger" *ngIf="isPayerIdMandatory">*</strong></label>
                  <input id="payer-id" class="form-control form-control-md vkeyboard uppercase-input"
                         type="text"
                         [(ngModel)]="payerId"
                         (ngModelChange)="validateUENField()"
                         #refId="ngModel"
                         [required]="isPayerIdMandatory"
                         placeholder="Enter Payer ID / UEN / FIN"
                         maxlength="10"
                         [ngClass]="{ 'is-invalid': payerIdInvalid }"/>
                  <div *ngIf="refId.invalid && refId.touched" class="text-danger mt-1">
                    <span class="error-icon">–</span>Payer Id is required.
                  </div>
                  <div *ngIf="payerIdInvalid" class="text-danger mt-1">
                    <span class="error-icon">–</span>Invalid Payer ID / UEN / FIN.
                  </div>
                </div>
              </div>
              <div class="right-column d-flex flex-column gap-3">
                <!-- Payer Name -->
                <div class="form-group" style="max-width: 400px">
                  <label for="payer-name" class="col-form-label">Payer Name <strong class="text-danger">*</strong></label>
                  <input id="payer-name" class="form-control form-control-md vkeyboard"
                         type="text"
                         [(ngModel)]="payerName"
                         #refName="ngModel"
                         required
                         placeholder="Enter Payer Name"
                         autocomplete="off"
                         [ngClass]="{ 'is-invalid': refName.invalid && refName.touched }" />
                  <div *ngIf="refName.invalid && refName.touched" class="text-danger mt-1">
                    <span class="error-icon">–</span>Payer Name is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="p-3 mb-1" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;" *ngIf="!getPayerIdMandatory(depositCategory)">
              <div class="mt-0 mb-0">
                Payer ID is only required for NRIC / UEN / FIN account holders. Not applicable for Passport / Foreign IDs.
              </div>
            </div>

            <div class="info-general d-flex justify-content-between">
              <div class="left-column d-flex flex-column gap-3">
                <!-- Contact Number -->
                <div class="form-group" style="max-width: 400px">
                  <label for="contact-number" class="col-form-label">Contact Number </label>
                  <input id="contact-number" class="form-control form-control-md vkeyboard"
                         [ngClass]="{ 'is-invalid': contact.invalid && contact.touched }"
                         type="text"
                         [(ngModel)]="contactNumber"
                         name="contactNumber"
                         maxlength="8"
                         minlength="8"
                         pattern="^[689][0-9]{7}$"
                         #contact="ngModel"
                         placeholder="Enter Contact Number"
                         autocomplete="off"
                         (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? null : $event.preventDefault()" />
                  <div *ngIf="contact.invalid && (contact.dirty || contact.touched)" class="text-danger mt-1">
                    <span class="error-icon">–</span>Please enter a Singapore registered phone number.
                  </div>
                </div>

              </div>
              <div class="right-column d-flex flex-column gap-3">
                <!-- Email -->
                <div class="form-group" style="max-width: 400px">
                  <label for="email" class="col-form-label">Email ID <strong class="text-danger" *ngIf="isEmailMandatory">*</strong></label>
                  <input id="email" class="form-control form-control-md vkeyboard"
                         type="email"
                         name="email"
                         [(ngModel)]="emailId"
                         email
                         [required]="isEmailMandatory"
                         #emailInput="ngModel"
                         pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                         placeholder="Email ID"
                         autocomplete="off"
                         [ngClass]="{ 'is-invalid': emailInput.invalid && emailInput.touched && emailInput.errors?.['email']}" />
                  <div *ngIf="(emailInput.touched || emailInput.dirty) && emailInput.invalid" class="text-danger mt-1">
                    <small *ngIf="emailInput.errors?.['email'] || emailInput.errors?.['pattern']"><span class="error-icon">–</span>Please enter a valid email address to receive receipt for your payment.</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-3 mb-1" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;" *ngIf="!isEmailMandatory">
              <div class="mt-0 mb-0">
                  Please enter either an email address or contact number to proceed with the deposit payment process.
              </div>
            </div>
            <!-- Amount -->
            <div class="form-group" style="max-width: 400px">
              <label for="amount" class="col-form-label">Amount (S$)<strong class="text-danger">*</strong></label>
              <input id="amount" class="form-control form-control-md vkeyboard"
                     type="text"
                     #amountInput="ngModel"
                     name="amount"
                     [(ngModel)]="amount"
                     (input)="onAmountInput($event)"
                     [ngClass]="{ 'is-invalid': (amountInput.invalid && amountInput.touched) || isAmountInvalid}"
                     required
                     autocomplete="off"
                     placeholder="Enter Amount Being Deposited" />
              <div *ngIf="amountInput.touched && amountInput.errors?.['required']" class="text-danger mt-1">
                <span class="error-icon">–</span>Amount is required.
              </div>
              <div *ngIf="amountZero" class="text-danger mt-1">
                <span class="error-icon">–</span>Amount must be greater than 0.
              </div>
              <div *ngIf="amountErrorMessage === 'PAYABLE_EXCEEDED'" class="text-danger mt-1">
                <span class="error-icon">–</span>Amount must not exceed {{ depositAmountLimit }}.
              </div>
            </div>

            <!-- Remarks -->
            <div class="form-group" style="max-width: 400px">
              <label for="remarks" class="col-form-label">Remarks</label>
              <input id="remarks" class="form-control form-control-md vkeyboard" type="text" [(ngModel)]="remarks" placeholder="Enter Remarks" />
            </div>
          </div>

        </div>

        <app-error-banner *ngIf="errorMessage" [message]="errorMessage"></app-error-banner>

        <div class="button-container d-flex gap-3 align-self-end">
          <button type="button" class="btn btn-outline" (click)="onCancel()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="!isFormValid" (click)="submitDepositDetails()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-virtual-keyboard></app-virtual-keyboard>



